var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconAdd = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0332031 10C0.0332031 4.48 4.58718 0 10.1983 0C15.8095 0 20.3635 4.48 20.3635 10C20.3635 15.52 15.8095 20 10.1983 20C4.58718 20 0.0332031 15.52 0.0332031 10ZM11.2149 11H15.2809V9H11.2149V5H9.18183V9H5.11577V11H9.18183V15H11.2149V11Z",
    fill: "current"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconAdd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-add.2aecd732.svg";
export { ForwardRef as ReactComponent };